import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { JhiAlertService } from 'ng-jhipster';

import { ICurrencies } from 'src/app/shared/model/currencies.model';
import { Principal } from 'src/app/core';

import { CurrencyService } from './currency.service';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { debounce } from "lodash";

@Component({
    selector: 'jhi-currency',
    templateUrl: './currency.component.html',
    styles: []
})
export class CurrencyComponent implements OnInit {
    currencies: ICurrencies[];
    searchText: string;
    flag: boolean;
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;
    constructor(
        private currencyService: CurrencyService,
        private jhiAlertService: JhiAlertService,
        public principal: Principal,
        private languageChangeService: LanguageChangeService,
        private activatedRoute: ActivatedRoute,
    ) { 
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    ngOnInit() {
        this.principal.setTitle("Exchange Rates");
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.getAllCurrencies();
    }

    getAllCurrencies() {
        this.currencyService
            .queryAll()
            .subscribe(
                (res: HttpResponse<ICurrencies[]>) => this.paginateCurrencies(res.body),
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }

    setAllCurrencies() {
        this.currencyService.save().subscribe(
            (res: HttpResponse<any>) => {
                if (res.body.status === 'OK') {
                    this.getAllCurrencies();
                }
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );
    }

    paginateCurrencies(data) {
        this.currencies = data;
    }
    trackId(index: number, item: ICurrencies) {
        return item.id;
    }
    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }
    searchItems() {
        // if (this.searchText) {
        //     let pNo = 0;
        //      let size =20;
        //     this.principal
        //         .searchQuery(this.searchText, 'currencyExchangeRate/search', {
        //             page: pNo,
        //             size: size
        //         })
        //         .subscribe(
        //             (res: HttpResponse<ICurrencies[]>) => this.paginateCurrencies(res.body),
        //             (res: HttpErrorResponse) => this.onError(res.message)
        //         );
        // } else {
        //     this.getAllCurrencies();
        // }

        this.searchUsingDebounce();
    }

    // history
    parentHistoryToggle = false;
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
    }

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Exchange Rates (' + Obj.name + ') History';
        this.historyType = "EXCHANGE_RATES_AUDIT";
        this.historyId = Obj.id;
    }
    onChange(value){
        let pNo = 0;
             let size =20;
        this.getAllCurrencies();
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            // this.parentFutureHistoryToggle = false;
        }
    }

    searchUsingDebounce = debounce(params => {
        if (this.searchText) {
            let pNo = 0;
            let size =20;
            this.principal
                .searchQuery(this.searchText, 'currencyExchangeRate/search', {
                    page: pNo,
                    size: size
                })
                .subscribe(
                    (res: HttpResponse<ICurrencies[]>) => this.paginateCurrencies(res.body),
                    (res: HttpErrorResponse) => this.onError(res.message)
                );
        } else {
            this.getAllCurrencies();
        }
    }, 700);
}
